import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 24, className = "", as = "div", ...rest }) => {
  const C = motion[as];
  return (
    <C
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.12 }}
      transition={{ duration: 0.7, delay, ease: EASE }}
      className={className}
      {...rest}
    >
      {children}
    </C>
  );
};

export const MaskLines = ({ lines, className = "", delay = 0.1, accentIndex = -1 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={line} className="block overflow-hidden pb-[0.08em]">
        <motion.span
          className={`block ${i === accentIndex ? "text-[#2878E5]" : ""}`}
          initial={{ y: "105%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 0.95, delay: delay + i * 0.12, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);
